/** Bundled fonts. Keep this catalog in one place so the inspector, browser
 * preview and PDF text rasterizer always use the same family. */
export const DEFAULT_FONT_FAMILY = 'Noto Sans';

export const FONT_OPTIONS = Object.freeze([
  { value: 'Noto Sans', label: 'Noto Sans — Modern' },
  { value: 'Noto Serif', label: 'Noto Serif — Klasik' },
  { value: 'Roboto', label: 'Roboto — Sade' },
  { value: 'Montserrat', label: 'Montserrat — Başlık' },
  { value: 'Lato', label: 'Lato — Kurumsal' },
  { value: 'Source Code Pro', label: 'Source Code Pro — Mono' },
  { value: 'Arial', label: 'Arial — Evrensel' },
  { value: 'Georgia', label: 'Georgia — Klasik serif' },
  { value: 'Verdana', label: 'Verdana — Ekran' },
  { value: 'Trebuchet MS', label: 'Trebuchet MS — Modern' },
  { value: 'Times New Roman', label: 'Times New Roman — Resmî' },
  { value: 'Courier New', label: 'Courier New — Daktilo' },
]);

const families = new Set(FONT_OPTIONS.map((option) => option.value));
export function normalizeFontFamily(input) {
  return families.has(input) ? input : DEFAULT_FONT_FAMILY;
}

export function cssFontStack(input) {
  const family = normalizeFontFamily(input);
  const fallback = family === 'Noto Serif' ? 'serif'
    : ['Source Code Pro','Courier New'].includes(family) ? 'monospace'
    : ['Georgia','Times New Roman'].includes(family) ? 'serif' : 'sans-serif';
  return `"${family}", ${fallback}`;
}

export function fontShorthand(size, input, style = {}) {
  const safeSize = Math.max(6, Math.min(144, Number(size) || 18));
  return `${style.italic ? "italic" : "normal"} ${style.bold ? "700" : "400"} ${safeSize}px ${cssFontStack(input)}`;
}
